module.exports = __webpack_public_path__ + "static/media/video4.35f48cb1.png";